import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { RareWordListProvider } from "./RareWordListContext";
import { DefinitionProvider } from "./DefinitionContext";
import { ArchiveDateProvider } from "./ArchiveDateContext";
import { SolutionsProvider } from "./SolutionsContext";
import GamePage from "./pages/GamePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ResetPasswordPage from "./components/ResetPasswordPage";
import MarketingPage from "./pages/Marketing";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { theme } from "./theme";
import { Provider, ErrorBoundary } from "@rollbar/react";
import SupportPage from "./pages/Support";
import MomentalSupport from "./pages/Momental/Support";
import MomentalPrivacy from "./pages/Momental/Privacy";
import MomentalLanding from "./pages/Momental/Landing";
import MomentalPressKit from "./pages/Momental/PressKit";
import { useClearFocusAfterDialogClose } from "./utils/focus";
import AnniversaryLanding from "./pages/Anniversary/Landing";

const rollbarConfig = {
  accessToken: "e44aa856dcec496da362867438f9d670",
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.REACT_APP_ROLLBAR_ENV,
};

const isEmbed =
  typeof window !== "undefined" &&
  window.location.hostname.endsWith("webview.devvit.net");

const isMomentalSubdomain =
  typeof window !== "undefined" &&
  window.location.hostname.startsWith("momental.");

const isAnniversarySubdomain =
  typeof window !== "undefined" &&
  window.location.hostname.toLowerCase().startsWith("laurenandluke15.");

export default function App() {
  useClearFocusAfterDialogClose();

  const content = isEmbed ? (
    <GamePage />
  ) : isAnniversarySubdomain ? (
    <AnniversaryLanding />
  ) : isMomentalSubdomain ? (
    <Router>
      <Routes>
        <Route path="/" element={<MomentalLanding />} />
        <Route path="/pressKit" element={<MomentalPressKit />} />
        <Route path="/support" element={<MomentalSupport />} />
        <Route path="/privacy" element={<MomentalPrivacy />} />
      </Routes>
    </Router>
  ) : (
    <Router>
      <Routes>
        <Route path="/" element={<GamePage />} />
        <Route
          path="/reset-password/:token"
          element={<ResetPasswordPage />}
        />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/marketing" element={<MarketingPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/LaurenAndLuke15" element={<AnniversaryLanding />} />
        <Route path="/Momental" element={<MomentalLanding />} />
        <Route path="/Momental/Support" element={<MomentalSupport />} />
        <Route path="/Momental/Privacy" element={<MomentalPrivacy />} />
        <Route path="/Momental/pressKit" element={<MomentalPressKit />} />
      </Routes>
    </Router>
  );

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>
        <ChakraProvider theme={theme}>
          <ArchiveDateProvider>
            <DefinitionProvider>
              <RareWordListProvider>
                <SolutionsProvider>{content}</SolutionsProvider>
              </RareWordListProvider>
            </DefinitionProvider>
          </ArchiveDateProvider>
        </ChakraProvider>
      </ErrorBoundary>
    </Provider>
  );
}
